// @flow

import AnalyticsFiltersNew from './index-new.jsx';
import V2AnalyticsFilters from './filters-v2.jsx';


export default AnalyticsFiltersNew;
export {V2AnalyticsFilters};
